export enum PromoScenarioOutputQueries {
  PromoScenarioResultKpi = 'promoScenarioResultKpi',
  PromoScenarioLineMonthLink = 'promoScenarioLineMonthLink',
  PromoScenarioLineQuarterLink = 'promoScenarioLineQuarterLink',
  PromoScenarioSkuMonthLink = 'promoScenarioSkuMonthLink',
  PromoScenarioSkuQuarterLink = 'promoScenarioSkuQuarterLink',
  PromoScenarioResult = 'promoScenarioResult',
}
